import { getAuth } from "firebase/auth";
import { authReady } from "@/lib/firebase";

export const setupGuards = (router) => {
  router.beforeEach(async (to) => {
    // Wait for Firebase to finish checking localStorage for a persisted session.
    // After this resolves, getAuth().currentUser is populated (or null).
    await authReady;

    const isAuthenticated = !!getAuth().currentUser;

    // Public routes pass through.
    if (to.meta.public) return true;

    // Not authenticated → redirect to login, preserving intended destination.
    if (!isAuthenticated) {
      return { name: "login", query: { redirect: to.fullPath } };
    }

    // Already logged in, trying to reach login → go to dashboard.
    if (to.name === "login") {
      return { name: "dashboard" };
    }

    return true;
  });
};
